import { Base, Component } from '@/vue-property-decorator'
import style from './style.module.scss'
//个人中心
import {
  CommonCopy,
  CommonCurrencyInfos
} from '@/components/business-components'
import { UserInfos } from '@/api/common/type'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import VipBadge from '../vip-badge'
@Component<BaseUserInfos>({
  name: 'BaseUserInfos'
})
export default class BaseUserInfos extends Base<unknown> {
  render() {
    const { userInfos } = useMainStore()
    const { t } = useI18n()
    const { platfromid } = userInfos as UserInfos
    return (
      <div class={style.main}>
        <div class={style.top}>
          <div class={[style['user-desc'], 'header-user__desc']}>
            <div class={[style['user-desc-top'], 'header-user_top']}>
              <div class={style.vipWrap}>
                <VipBadge />
              </div>
              <div class={style.wrap}>
                <span class={style.title}>{t('lobby.header.account')} </span>
                <span class={style.platfromId}>{platfromid}</span>
              </div>
              <CommonCopy class={style.copyIcon} text={platfromid} />
            </div>
            <CommonCurrencyInfos />
          </div>
        </div>
      </div>
    )
  }
}
